export const RANDOM_ORDER_BY = 'random';
export const UPDATED_AT_DESC = 'updatedAt_DESC';
